import app from 'flarum/forum/app';
import ForumApplication from 'flarum/forum/ForumApplication';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';
import LinkButton from 'flarum/common/components/LinkButton';
import { extend } from 'flarum/common/extend';
import MarketsPage from './forum/MarketsPage';
import RadarPage from './forum/RadarPage';
import MarketTicker from './forum/MarketTicker';
import CoveragePage from './forum/CoveragePage';

app.initializers.add('gardensel-markets', () => {
  app.routes.gardenselBorsa = { path: '/borsa', component: MarketsPage };
  app.routes.gardenselBorsaRadar = { path: '/borsa/radar', component: RadarPage };
  app.routes.gardenselBorsaCoverage = { path: '/borsa/kapsam', component: CoveragePage };
  app.routes.gardenselBorsaProduct = { path: '/borsa/:slug', component: MarketsPage };

  extend(HeaderPrimary.prototype, 'items', (items) => {
    items.add(
      'gardenselMarkets',
      <LinkButton href={app.route('gardenselBorsa')} icon="fas fa-chart-line">
        Tarım Fiyatları
      </LinkButton>,
      15
    );
  });

  extend(IndexPage.prototype, 'contentItems', (items) => {
    items.add(
      'gardenselMarketsCta',
      <section className="MarketsHomeCta" aria-labelledby="markets-home-cta-title">
        <div>
          <span>GARDENSEL BORSA · RESMÎ PİYASA REFERANSLARI</span>
          <h2 id="markets-home-cta-title">Ürününüzün güncel fiyatı ne kadar?</h2>
          <p>Türkiye'nin hal ve borsa fiyatlarını karşılaştırın; geçmiş fiyatı ve reel pahalı/ucuz analizini görün.</p>
          <small>Resmî piyasa referansları satış teklifi değildir.</small>
        </div>
        <Link className="Button Button--primary" href={app.route('gardenselBorsa')}>Gardensel Borsa'yı Aç</Link>
      </section>,
      94
    );
  });

  extend(ForumApplication.prototype, 'mount', function () {
    let host = document.getElementById('gardensel-market-ticker');
    const content = document.querySelector('.App-content');
    if (!host && content && content.parentNode) {
      host = document.createElement('div');
      host.id = 'gardensel-market-ticker';
      host.className = 'MarketTickerHost';
      content.parentNode.insertBefore(host, content);
    }
    if (host) m.mount(host, MarketTicker);
  });
});
